import { format, parseISO } from 'date-fns'

export const DateUtils = {
  short: (date: string = new Date().toISOString()) => {
    return format(parseISO(date), 'dd/MM/yyyy')
  },
  file: (date: string = new Date().toISOString()) => {
    return format(parseISO(date), 'dd MMM yyyy')
  },
}
